import {config} from '../config';

export default {
    getLocalizationMapping: () => config.data.localization.localizationMapping,
    getLanguages: () => config.data.localization.languages,
};
